import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { SettingsResponse } from "../../types/settings-response"
import { settingsService } from "../../services/settingsService"
import { showErrorMessage } from "../../redux/reducers/snackbarReducer"

export const useDepartmentSettings = (departmentId: number | undefined | null) => {
  const [departmentSettings, setDepartmentSettings] = useState<SettingsResponse | null>(null)
  const dispatch = useDispatch()

  useEffect(() => {
    if (departmentId) {
      settingsService.getSettings(departmentId)
      .then(settings => {
        setDepartmentSettings(settings)
      })
      .catch(e => dispatch(showErrorMessage(e.message)))
    }
  }, [departmentId])

  return departmentSettings
}